import numeral from 'numeral';

export const dollars = (amount) => {
  return numeral(amount).format('$0,0.00');
}



// WEBPACK FOOTER //
// ./src/utils/money.js